


window.mmajaxcart = {
  AjaxcartOpen: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.addClass('mm-no-scroll');
    ajaxCart.addClass('has--opened');      
    ajaxOverlay.addClass('has--active');
  },
  AjaxcartClose: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),           	
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.removeClass('mm-no-scroll');
    ajaxCart.removeClass('has--opened');      
    ajaxOverlay.removeClass('has--active');       
  },
  AjaxcartRender: function() {
    $.get('/cart?view=cart-ct', function(cart){


      
      var remove_true=false;      
var add_true=false;
     fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {
      //console.log(data);
      var price= Math.floor(data.total_price / 100);    
     // console.log(price,"::::price");
      var data_items = data.items.length;
      console.log(data_items,"::data_items");
      
      jQuery('.remove_ct_btn:first').click();
      
      if(price === 0 && data_items > 0) {
        
         //console.log(price,"::::price nnnnnnn");
            // Clear the cart
            fetch(window.Shopify.routes.root + 'cart/clear.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(() => {
              mmajaxcart.AjaxcartRender(); // Re-render the cart after clearing it
              updateCartItemCount();
               $(".mm-ajaxcart-button .loader").addClass("pointer-events");
      $(".mm-ajaxcart .loader-main").show();

              setTimeout(function(){
        $(".mm-ajaxcart-button").css("pointer-events", "");
         $(".mm-ajaxcart .loader-main").hide();
        $(".mm-ajaxcart-button .loader").removeClass("pointer-events");
      }, 2000); // Remove the class after 2 seconds
            });
          }

      function updateCartItemCount() {
  // Fetch the cart data to get the item count
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(cart => {
    // Update the cart item count in the DOM
    const cartItemCountElement = document.querySelector('.cart_count_class');
    if (cartItemCountElement) {
      cartItemCountElement.textContent = cart.item_count;
    }
  });
}

        var prod_id="";
      
      data.items.forEach(pr => {
        if(pr.id == 43136408453304)
          {
            prod_id = pr.id;
           // add_true=true
           //return false;
          }  
        if(price > 1500)
        {                   
          if(pr.id != 43136408453304)
          {
           add_true=true
           return false;
          }  
        }
        if(price < 1500) 
        {
          
          if(pr.id == 43136408453304)
          {
            // console.log("ddd")
            remove_true=true;                 
            return false;
          }          
        }
        
      });
    // console.log(add_true+"== "+remove_true)
      if(add_true && prod_id != 43136408453304)
      {
        addFreeGift();
      }
       if(remove_true)
      {
         removeFreeGift(); 
      }
      
    })
    .catch(error => {
        console.error('Error:', error);
    });


        // getCartData().then(Cart_price => {
        //     let Price = Cart_price;    
        //     if (Price >= 1500  ) {
        //         console.log("addFreeGift");
        //         addFreeGift();       
        //     } else {
              
        //         console.log("removeFreeGift");
        //         removeFreeGift();       
        //     }
        // });
      
      $('.mm-ajaxcart').html(cart);

      const parser = new DOMParser();
      const cartHTML = parser.parseFromString(cart, 'text/html');
      const cartCount = cartHTML.querySelector('.mm-ajaxcart-header p').innerText.match(/\((\d+)\)/)?.[1]
    //  document.querySelector("#cart-icon-bubble > div > span.visually-hidden").innerHTML = cartCount + " items";
     // document.querySelector("#cart-icon-bubble > div > span:nth-child(1)").innerHTML = cartCount;
      document.querySelectorAll('.header-cart__count').forEach( elem => elem.innerText = cartCount);
          //mmajaxcart.Ajaxupsell();
    })

  },
  AjaxcartChangeHandler: function(data) { 
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      success: function (cart) {
        mmajaxcart.AjaxcartRender();
        
        let CartCount = cart.item_count; 
        document.querySelectorAll('.header-cart__count').forEach((elem)=>{
          elem.innerText=cart.item_count;
        })
        $('.cart_count_class').html(CartCount);
      }
    });
    
  },
  
  AjaxcartUpdateHandler: function(data) { 
    let formData = {
       updates:data
      };

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    }).then(cart=>{
      mmajaxcart.AjaxcartRender();
      
      let CartCount = cart.item_count; 
      document.querySelectorAll('.header-cart__count').forEach((elem)=>{
          elem.innerText=cart.item_count;
      })
      $('.cart_count_class').html(CartCount);
    })
    .catch((error) => {
      console.error('Error:', error);
    });

    // $.ajax({
    //   url: '/cart/update.js',
    //   dataType: 'json',
    //   cache: false,
    //   type: 'post',
    //   data: formData,
    //   success: function (cart) {
    //     mmajaxcart.AjaxcartRender();
    //     var CartCount = cart.item_count; 
    //     document.querySelector('.header-cart__count').innerText=cart.item_count;
    //     $('.mm-cart-count').html(CartCount);
    //   }
    // });
    
  },
   
  AjaxcartQuantityHandler: function() {
    function updateQuantity(elem) {      
      var UpdatedQuantity = parseInt($(elem).val()),
      QuantityLine = parseInt($(elem).attr('data-line')),
      params = { quantity: UpdatedQuantity, line: QuantityLine };

      let parent = elem.closest("[data-custom-product]")
      let customProductQnty = UpdatedQuantity;
      if(elem.closest("[data-custom-product]")){
        document.querySelectorAll("[data-custom-product]").forEach((ele)=>{
          if(ele != parent[0]){
            customProductQnty = customProductQnty + parseInt(ele.dataset.quantity);
          }
        })
        params = { };
        let parentKey = $(elem).attr('data-key')
        let addOnKey = document.querySelector("[data-addOnproduct]")

        params[parentKey] = UpdatedQuantity
        if(addOnKey)
        { 
          addOnKey = addOnKey.dataset.key
          params[addOnKey] = customProductQnty
        };
        mmajaxcart.AjaxcartUpdateHandler(params);
      }else{
        mmajaxcart.AjaxcartChangeHandler(params);
      }
      
    }

    $(document).on('change', '.quantity-input', function() {
     // debugger
      updateQuantity($(this).parent().find('.quantity-input'))
      
      
    }) 	
    $(document).on('click', '.quantity-plus', function() {
      $(".mm-ajaxcart-button .loader").addClass("pointer-events");
      $(".mm-ajaxcart .loader-main").show();
      
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) + p;

      $(this).parent().find('.quantity-input').val(u)
      updateQuantity($(this).parent().find('.quantity-input'))

      setTimeout(function(){
        $(".mm-ajaxcart-button").css("pointer-events", "");
         $(".mm-ajaxcart .loader-main").hide();
        $(".mm-ajaxcart-button .loader").removeClass("pointer-events");
      }, 2000); // Remove the class after 2 seconds

    })
    $(document).on('click', '.quantity-minus', function() {
        $(".mm-ajaxcart-button .loader").addClass("pointer-events");
        $(".mm-ajaxcart .loader-main").show();
        $(".mm-ajaxcart-button").css("pointer-events", "none");
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) - p;


      // $(this).parent().find('.quantity-input').val(u).trigger('change');
      $(this).parent().find('.quantity-input').val(u)
      updateQuantity($(this).parent().find('.quantity-input'))

       setTimeout(function(){
        $(".mm-ajaxcart-button").css("pointer-events", "");
         $(".mm-ajaxcart .loader-main").hide();
        $(".mm-ajaxcart-button .loader").removeClass("pointer-events");
      }, 2000); // Remove the class after 2 seconds
      
    })
  },
  AjaxcartRemoveItem: function() {
    $(document).on('click', '.mm-ajaxcart-remove-item', function() {
       $(".mm-ajaxcart-button .loader").addClass("pointer-events");
        $(".mm-ajaxcart .loader-main").show();
       $(".mm-ajaxcart-button").css("pointer-events", "none");
      var RemoveLine = parseInt($(this).attr('data-line')),
          params = { quantity: 0, line: RemoveLine };

      let parent = this.closest("[data-custom-product]")
      
      
      if( parent && parent.hasAttribute('data-custom-product')){
        let UpdatedQuantity = parseInt(parent.querySelector('input').value)
        let customProductQnty = 0;
        if(parent){
          document.querySelectorAll("[data-custom-product]").forEach((ele)=>{
            if(ele != parent){
              customProductQnty = customProductQnty + parseInt(ele.dataset.quantity);
            }
          })
          params = { };
          let parentKey = parent.dataset.key
          let addOnKey = document.querySelector("[data-addOnproduct]")
       
          params[parentKey] = 0
          if(addOnKey)
          { 
            addOnKey = addOnKey.dataset.key
            params[addOnKey] = customProductQnty
          };
          mmajaxcart.AjaxcartUpdateHandler(params);
        }
      }
      
      mmajaxcart.AjaxcartChangeHandler(params);
      setTimeout(function(){
        $(".mm-ajaxcart-button").css("pointer-events", "");
        $(".mm-ajaxcart-button .loader").removeClass("pointer-events");
        $(".mm-ajaxcart .loader-main").hide();
      }, 1500); // Remove the class after 2 seconds
    })
  },
  Ajaxupsell: function(){
  
  },

}


$(document).ready(function() { 
  $(document).on('click', '.mm-ajaxcart-open', function(e) {
  	e.preventDefault();
    mmajaxcart.AjaxcartOpen();
    mmajaxcart.AjaxcartRender();
    mmajaxcart.Ajaxupsell();
  })
  $(document).on('click', '.mm-ajaxcart-close', function(e) {
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
  });
   $(document).on('click', '.mm-ajaxcart-overlay', function(e){
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
  });
  
  mmajaxcart.AjaxcartRender();
  mmajaxcart.AjaxcartRemoveItem();
  mmajaxcart.AjaxcartQuantityHandler();
  
  $(document).on('click', '.ct_cart_clear', function(e) {
    $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() {
            mmajaxcart.AjaxcartRender();
        },
        error: function(XMLHttpRequest, textStatus) {
          /* error code */
        }
      });
  })
    $(document).on('click', '.add-to-cart', function() {

      jQuery(this).closest('.wrap_gift-options').find('.add-to-cart').attr('disabled','disabled');
      
      var variantId = $(this).attr('data-variantids')
      console.log(variantId);
      var data = {
        id: variantId,
        quantity: 1
      };
      fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        $(".mm-ajaxcart-button .loader").addClass("pointer-events");
        $(".mm-ajaxcart .loader-main").show();
        
        
        setTimeout(function(){
        $(".mm-ajaxcart-button").css("pointer-events", "");
        $(".mm-ajaxcart .loader-main").hide();
        $(".mm-ajaxcart-button .loader").removeClass("pointer-events");
        }, 2000); // Remove the class after 2 seconds
        
        mmajaxcart.AjaxcartOpen();
        mmajaxcart.AjaxcartRender();   
        
        
      }).catch(function(err) {
        /* uh oh, we have error. */
        console.error(err)
      });
    });
})

 
function addFreeGift() {
    var id = "43136408453304";
   
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: { id: id, quantity: 1 },
                    success: function() {
                       mmajaxcart.AjaxcartRender();
                        //location.href="/cart";
                    }
                });
        
}

function removeFreeGift(){
  let updates = {
    43136408453304: 0
  };
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {

    mmajaxcart.AjaxcartRender();
  })
  .catch((error) => {
    console.error('Error:', error);
  });

}

// $(document).on('click', '.ct_Cprice', function() {
//     getCartData().then(Cart_price => {
//         console.log(Cart_price);
//     });
// });

function getCartData() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {
      return Math.floor(data.total_price / 100);
    })
    .catch(error => {
        console.error('Error:', error);
    });
}